import React from "react";
import "./Renderlist.css";
function Renderlist(props) {
  return (
    <div className="list">
      <ul className="ul">
        {props.todoList.map((item, idx) => {
          return (
            <li className="listitem" key={`${idx}${item}`}>
            <div>{item}</div> 
            <div><button
                id="delete-btn"
                onClick={()=>{
                    props.handleDeleteTodo(item)
                }}
              >
                Delete
              </button>{" "}</div> 
              
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default Renderlist;
